export default __webpack_public_path__ + "static/media/homePageBgPic-3.2f0633d3.jpg";